<section
    class="agpr-leftSidebar"
    [ngClass]="{
        'agpr-hideSidebar': hideSidebar,
        'agpr-collapseSidebar': collapseSidebar
    }"
    [attr.aria-label]="'Common.layout.lhp' | localize"
>
    <!-- Collapse Button -->
    <div class="agpr-leftSidebar-toggle agpr-contentToggle">
        <agpr-button
            [icon]="collapseSidebar ? 'fa-solid fa-angle-right' : 'fa-solid fa-angle-left'"
            [style]="buttonTypes.icon"
            [tooltip]="collapseSidebar ? ('Core.expand' | localize) : ('Core.collapse' | localize)"
            (click)="collapseLeftSidebar();"
        ></agpr-button>
        <div class="agpr-contentToggle-line"></div>
    </div>

    @if (primaryHeading) {
        <h1 class="u-srOnly">{{ primaryHeading | localize }}</h1>
    }

    <div class="agpr-leftSidebar-content">
        <!-- Dropdown -->
        @if (dropdownItems.length > 0) {
            <nav class="agpr-leftSidebar-navbar">
                @if (!collapseSidebar) {
                    <agpr-dropdown
                        [id]="`${id}_dropdown`"
                        class="agpr-leftSidebar-navbar-dropdown"
                        panelStyleClass="agpr-dropdown-panelLHP"
                        ariaLabel="Common.moduleSelector"
                        [options]="dropdownItems"
                        [ngModel]="selectedDropdownItem"
                        (ngModelChange)="dropdownSelectionChanged($event)"
                        [inputTooltip]="selectedDropdownItem?.label"
                        [showTooltip]="true"
                    ></agpr-dropdown>
                }
                @if (actionButtons.length) {
                    <agpr-kebab-menu
                        [id]="`${id}_actions`"
                        class="agpr-leftSidebar-navbar-kebab"
                        icon="fa-regular fa-duotone fa-square-plus"
                        [options]="actionButtons"
                        [style]="buttonTypes.icon"
                        panelPositionY="bottom"
                        [panelPositionX]="collapseSidebar ? 'left' : 'right'"
                    ></agpr-kebab-menu>
                } @else {
                    @if (!hideAmplifyButton) {
                        <agpr-button
                            [id]="`${id}_amplify`"
                            icon="fa-regular fa-duotone fa-square-plus"
                            [tooltip]="localizations?.amplifyButton"
                            [disabled]="!buttonEnabled"
                            (click)="sidebarService.amplifyButtonClicked()"
                            [style]="buttonTypes.icon"
                        ></agpr-button>
                    }
                }
            </nav>
        }

        @if (!collapseSidebar && hideList && dashboardListItem) {
            <div class="agpr-leftSidebarItems-dashboard-container">
                <ng-container *ngTemplateOutlet="dashboardButton"></ng-container>
            </div>
        }

        <!-- List Items -->
        <div
            *ngIf="!collapseSidebar && !hideList"
            class="agpr-leftSidebarItems"
        >
            <div
                *ngIf="hasFilters && !hideFilter"
                class="agpr-leftSidebarItems-filter"
            >
                <span
                    class="agpr-leftSidebarItems-filterDropdown"
                    [ngClass]="{'agpr-leftSidebarItems-filterDropdown--chips': hasFilterChips}"
                >
                    <agpr-filter-dropdown
                        [id]="`${id}_filters`"
                        class="agpr-leftSidebarItems-filterDropdown--filter"
                        [showQuickFilter]="true"
                        [quickFilterPlaceholder]="quickFilterPlaceholder"
                        [minLength]="quickFilterMinLength"
                        [ariaLabel]="quickFilterPlaceholder | localize"
                        [ariaDescribedBy]="hasFilterChips ? `${id}_filters_chips`: ''"
                    ></agpr-filter-dropdown>
                    <agpr-sort-order
                        [id]="id + '_sortOrder'"
                        class="agpr-leftSidebarItems-filterDropdown--sort"
                        tooltip="Discover.targeting.tooltips.sort"
                        optionKey="enumValue"
                        optionLabel="displayString"
                    ></agpr-sort-order>
                </span>
                <span
                    *ngIf="hasFilterChips"
                    class="agpr-leftSidebarItems-filterChips"
                >
                    <agpr-filter-chips [id]="`${id}_filters_chips`"></agpr-filter-chips>
                </span>
            </div>

            @if (!loadingItems && dashboardListItem) {
                <ng-container *ngTemplateOutlet="dashboardButton"></ng-container>
            }

            <div
                *ngIf="loadingItems"
                class="agpr-leftSidebar-loading"
                [agprLoading]="true"
                [agprInlineLoadingIndicator]="true"
                [loadingLightMode]="sidebarColorTheme === sidebarColorThemes.DARK"
            >
            </div>
            <nav class="agpr-leftSidebarItems-nav">
                <cdk-virtual-scroll-viewport
                    #virtualScrollPanel
                    *ngIf="groupedListItems.length"
                    class="agpr-virtualScroll"
                    [itemSize]="ITEM_HEIGHT"
                    minBufferPx="800"
                    maxBufferPx="1200"
                >
                    <h3 class="u-srOnly">{{ (localizations?.itemsHeading | localize) + ' ' + ('list' | localize) }}</h3>
                    <ul
                        [id]="`${id}_list`"
                        class="agpr-leftSidebarGroups"
                    >
                        <li
                            *cdkVirtualFor="let lhpItem of flattenedItems; index as i; trackBy: trackByFn"
                            [id]="lhpItem.type === lhpItemTypes.group ? `${id}_listItem_group_${lhpItem.group.id ?? lhpItem.group.type}` : `${id}_listItem_${lhpItem.item.value}`"
                            [class]="lhpItem.type === lhpItemTypes.group ? 'agpr-leftSidebarGroups-group' : 'agpr-leftSidebarItems-item'"
                            [ngClass]="{
                                'agpr-leftSidebarGroups-group--empty': lhpItem.type === lhpItemTypes.group &&
                                    (!showGroupHeaders ||
                                    ((lhpItem.group.type === displayGroupTypes.favorites || lhpItem.group.type === displayGroupTypes.uncategorized) &&
                                        !lhpItem.group.listItems?.length
                                    ))
                            }"
                            [pTooltip]="
                                lhpItem.type === lhpItemTypes.group ? lhpItem.group.name :
                                (lhpItem.item.tooltip ? lhpItem.item.tooltip :
                                (lhpItem.item.status ? lhpItem.item.label + ' - ' + (lhpItem.item.status | localize) : lhpItem.item.label))"
                        >
                            <ng-container [ngSwitch]="lhpItem.type">
                                <ng-container *ngSwitchCase="lhpItemTypes.group">
                                    <button
                                        *ngIf="showGroupHeaders &&
                                            (lhpItem.group.listItems.length || (lhpItem.group.type !== displayGroupTypes.favorites && lhpItem.group.type !== displayGroupTypes.uncategorized))"
                                        [id]="`${id}_group_${lhpItem.group.id ?? lhpItem.group.type}_toggleButton`"
                                        class="agpr-leftSidebarGroups-header"
                                        (click)="toggleGroup(lhpItem)"
                                        [disabled]="!(lhpItem.group.listItems?.length > 0)"
                                    >
                                        <span
                                            class="agpr-leftSidebarGroups-title"
                                        >
                                            {{ lhpItem.group.name}}
                                        </span>
                                        <div class="agpr-leftSidebarGroups-menu">
                                            <agpr-kebab-menu
                                                [id]="`${id}_listItem_group_${lhpItem.group.id}_kebabMenu`"
                                                *ngIf="lhpItem.group.type !== displayGroupTypes.favorites && lhpItem.group.type !== displayGroupTypes.uncategorized"
                                                class="agpr-leftSidebarGroups-actions"
                                                [options]="groupOptions"
                                                [data]="lhpItem.group"
                                                [tooltip]="'Common.lhp.groups.options'"
                                                panelPositionX="right"
                                            >
                                            </agpr-kebab-menu>
                                        </div>
                                        <span
                                            class="agpr-expandToggle fa-solid"
                                            [ngClass]="{
                                                'fa-angle-down': !(lhpItem.group.listItems?.length > 0) || lhpItem.collapsed,
                                                'fa-angle-up': lhpItem.group.listItems?.length > 0 && !lhpItem.collapsed,
                                                'agpr-expandToggle--disabled': !(lhpItem.group.listItems?.length > 0)
                                            }"
                                            ></span>
                                    </button>
                                </ng-container>

                                <ng-container *ngSwitchDefault>
                                    <span
                                        class="agpr-leftSidebarItems-item--activeBar"
                                        [ngClass]="{'agpr-leftSidebarItems-item--activeBar-show': selectedItem && selectedItem.value == lhpItem.item.value}"
                                    ></span>
                                    <div
                                        class="agpr-leftSidebarItems-container"
                                        [ngClass]="{
                                            'agpr-leftSidebarItems-item--active': selectedItem && selectedItem.value == lhpItem.item.value,
                                            'agpr-leftSidebarItems-container--disabled': lhpItem.item.disabled
                                        }"

                                    >
                                        <a
                                            [id]="`${lhpItem.id}_listItem_${i}_link`"
                                            [class]="itemLabelClassName"
                                            [ngClass]="{'agpr-leftSidebarItems-itemLabel-disabled': lhpItem.item.disabled, 'agpr-leftSidebarItems-itemLabel--withBlockLimitIndicator': lhpItem.item.indicator?.includes('itemIcon-blockLimit')}"
                                            tabindex="0"
                                            (keydown)="selectListItem(lhpItem.item, $event)"
                                            (click)="selectListItem(lhpItem.item, $event)"
                                        >
                                            @if (lhpItem.item.leadingIcon) {
                                                <span
                                                    class="agpr-leftSidebarItems-itemIcon agpr-leftSidebarItems-itemIcon--leading"
                                                    [ngClass]="lhpItem.item.leadingIcon"
                                                    [pTooltip]="lhpItem.item.leadingIconTooltip"
                                                    aria-hidden="true"
                                                ></span>
                                            }
                                            <span
                                                *ngIf="lhpItem.item.icon"
                                                class="agpr-leftSidebarItems-itemIcon"
                                                [ngClass]="lhpItem.item.icon"
                                                aria-hidden="true"
                                            ></span>
                                            @if(lhpItem.item.indicator) {
                                                <span
                                                    class="agpr-leftSidebarItems-itemIcon"
                                                    [ngClass]="lhpItem.item.indicator"
                                                    [pTooltip]="lhpItem.item.indicatorTooltip | localize "
                                                    aria-hidden="true"
                                                ></span>
                                            }
                                            <span class="u-srOnly">{{ lhpItem.item.iconAriaLabel | localize }}</span>
                                            {{ lhpItem.item.label | localize }}
                                        </a>
                                        <span
                                            class="agpr-leftSidebarItems-itemStatus"
                                            [ngClass]="{'agpr-leftSidebarItems-itemStatus-noButton': !lhpItem.item.buttons?.length}"
                                            *ngIf="lhpItem.item.state !== actionsEnum.delete"
                                        >
                                            {{ lhpItem.item.status | localize }}
                                        </span>
                                        @if (!lhpItem.item.disabled) {
                                            <agpr-kebab-menu
                                                [id]="`${lhpItem.id}_listItem_${lhpItem.item.value}_kebabMenu`"
                                                *ngIf="!!lhpItem.item.buttons && lhpItem.item.buttons.length > 0 && lhpItem.item.state !== actionsEnum.delete"
                                                #kebabMenu
                                                class="agpr-leftSidebarItems-optionButton"
                                                [ngClass]="{'agpr-leftSidebarItems-optionButton--active': selectedItem && selectedItem.value == lhpItem.item.value}"
                                                [options]="lhpItem.item.buttons"
                                                [data]="lhpItem.item"
                                                [ariaLabel]="'Discover.leftSidebar.listItemAction.buttonAriaLabel' | localize"
                                                panelPositionX="right"
                                            ></agpr-kebab-menu>
                                        }
                                        @if (lhpItem.item.secondaryOption && lhpItem.item.state !== actionsEnum.delete) {
                                            <div
                                                [id]="`${lhpItem.id}_listItem_${i}_secondaryOption`"
                                                class="agpr-leftSidebarItems-secondaryOption"
                                            >
                                                <agpr-button
                                                    [id]="`${lhpItem.id}_listItem_${i}_loadSubItems`"
                                                    [icon]="'fa-solid fa-angle-right'"
                                                    [style]="buttonTypes.icon"
                                                    (click)="loadSubitems(lhpItem.item)"
                                                >
                                                </agpr-button>
                                            </div>
                                        }
                                        @if (lhpItem.item.state === actionsEnum.delete) {
                                            <div
                                                [agprLoading]="true"
                                                [agprInlineLoadingIndicator]="true"
                                                [loadingSmallIndicator]="true"
                                            >
                                            </div>
                                        }

                                    </div>
                                </ng-container>
                            </ng-container>
                        </li>
                        <li
                            class="agpr-leftSidebarItems-item"
                        ></li>
                    </ul>
                </cdk-virtual-scroll-viewport>
                <agpr-message
                    *ngIf="!loadingItems && (!listItems || listItems.length === 0)"
                    class="agpr-leftSidebar-noItemsMessage"
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ localizations?.noItems | localize }}
                </agpr-message>
            </nav>

            <div
                *ngIf="hiddenListItems?.length && !this.collapseList && !collapseSidebar"
                class="agpr-leftSidebar-showHidden-container"
                [ngClass]="{'agpr-leftSidebar-showHidden-container--french': french}"
            >
                <div
                    class="agpr-leftSidebar-showHidden"
                >
                    <agpr-button
                        [id]="`${id}_showAllHidden`"
                        class="agpr-leftSidebar-showHidden-link"
                        [style]="buttonTypes.link"
                        [label]="'Monitor.leftSideBar.showHidden.label' | localize: { count: hiddenListItems.length }"
                        (click)="showAllHiddenItems()"
                        [underline]="true"
                    ></agpr-button>
                </div>
            </div>

            <div class="agpr-leftSidebar-footer">
                <div class="agpr-leftSidebar-footer-inner">
                    <span class="agpr-leftSidebar-footer-itemCount">{{ listItems.length }} {{ localizations?.itemsHeading | localize }}</span>
                    <div class="agpr-leftSidebar-footer-actions">
                        @if (showUngroupedViewButton) {
                            <agpr-button
                                [id]="`${id}_toggleView`"
                                [icon]="showUngroupedView ? 'fa-regular fa-list-tree' : 'fa-regular fa-list'"
                                [style]="buttonTypes.icon"
                                [tooltip]="showUngroupedView ? 'Discover.leftSidebar.listItemAction.showGroup' : 'Discover.leftSidebar.listItemAction.showList'"
                                (click)="toggleUngroupedView()"
                            ></agpr-button>
                        }
                        <ng-container
                            *ngTemplateOutlet="manageListKebab; context: {hide: hideManageListDialog, options: manageListMenuOptions, disabled: !listItems?.length && !hiddenListItems?.length}"
                        ></ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="collapseSidebar && !hideList" class="agpr-leftSidebar-footer agpr-leftSidebar-footer--collapsed">
            <div class="agpr-leftSidebar-footer-inner">
                <ng-container
                    *ngTemplateOutlet="manageListKebab; context: {hide: hideManageListDialog, options: manageListMenuOptions, disabled: !listItems?.length && !hiddenListItems?.length}"
                ></ng-container>
            </div>
        </div>

        <a *ngIf="hasBrandGUID" href="//www.agilitypr.com/" target="_blank" class='agpr-branding-poweredBy' aria-label="Agility PR Solutions Website">
            <img [src]="agilityLogoUrl" alt="Agility PR Solutions">
        </a>

        <div
            class="agpr-leftSidebar-subListItems"
            (clickOutside)="hideSubitems()"
            *ngIf="showSubitems"
            tabindex="0"
            id="leftSidebar_subListItems"
            cdkTrapFocus
            [cdkTrapFocusAutoCapture]="true"
        >
            <div class="agpr-leftSidebar-subListItems-headerContainer">
                <span class="agpr-leftSidebar-subListItems-header">
                    {{ secondaryOptionLabel | localize }}
                </span>
                <span class="agpr-leftSidebar-subListItems-spacer"></span>
                <span>{{subitems.length}} {{ secondaryOptionLabel | localize }}</span>
            </div>
            <nav class="agpr-leftSidebarItems-nav">
                <cdk-virtual-scroll-viewport
                    #subitemVirtualScrollPanel
                    *ngIf="subitems?.length"
                    class="agpr-virtualScroll"
                    [itemSize]="SUB_ITEM_HEIGHT"
                    minBufferPx="800"
                    maxBufferPx="1200"
                >
                    <h2 class="u-srOnly">{{ (secondaryOptionLabel | localize) + ' ' + ('list' | localize) }}</h2>
                    <ul
                        #subItemList
                        [id]="`${id}_subListItems_list`"
                        [attr.aria-label]="secondaryOptionLabel | localize"
                    >
                        <li
                            *cdkVirtualFor="let item of subitems; index as i"
                            [id]="`${id}_subListItems_listItem_${i}`"
                            [pTooltip]="(item.tooltip ? item.tooltip : item.label) | localize "
                            class="agpr-leftSidebar-subListItems-itemContainer"
                        >
                            <span
                                class="agpr-leftSidebarItems-item--activeBar"
                                [ngClass]="{'agpr-leftSidebarItems-item--activeBar-show': selectedSubitem?.id == item.id}"
                            ></span>
                            <div
                                class="agpr-leftSidebarItems-container"
                                tabindex="0"
                                [id]="`${id}_subListItems_listItem_${i}_container`"
                                (keydown)="selectSubitem(item, $event)"
                                (click)="selectSubitem(item, $event)"
                            >
                                <a [id]="`${id}_subListItems_listItem_${i}_link`">
                                    {{ item.label | localize }}
                                </a>
                            </div>
                        </li>
                    </ul>
                </cdk-virtual-scroll-viewport>
                <agpr-message
                    *ngIf="!subitems || subitems.length === 0"
                    class="agpr-leftSidebar-noItemsMessage"
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ localizations?.noItems | localize }}
                </agpr-message>
            </nav>
        </div>
    </div>
</section>

<ng-template #manageListKebab let-hide="hide" let-options="options" let-disabled="disabled">
    <agpr-kebab-menu
        *ngIf="!hide"
        [id]="`${id}_manageListKebabMenu`"
        class="agpr-leftSidebar-footer-kebabMenu"
        icon="fa-regular fa-duotone fa-gear"
        [panelPositionX]="collapseSidebar ? 'left' : 'right'"
        panelPositionY="top"
        [options]="options"
        tooltip="Common.lhp.manageList.kebabMenu.tooltip"
        tooltipPosition="right"
        [disabled]="disabled"
    ></agpr-kebab-menu>
</ng-template>

<ng-template #dashboardButton>
    <div
        [id]="`${id}_dashboard`"
        class="agpr-leftSidebarItems-dashboard"
        [ngClass]="{
            'agpr-leftSidebarItems-dashboard--active': selectedItem?.value === dashboardListItem?.value
        }"
        (click)="selectListItem(dashboardListItem, $event);"
    >
        <div class="agpr-leftSidebarItems-dashboard-activeBar"></div>
        <div class="agpr-leftSidebarItems-dashboard-content" tabIndex="0">
            <span
                class="agpr-leftSidebarItems-dashboard-icon"
                [ngClass]="dashboardListItem.icon"
                role="img"
            ></span>
            <span class="agpr-leftSidebarItems-dashboard-label">
                {{ dashboardListItem.label | localize }}
            </span>
        </div>
    </div>
</ng-template>
